import React from "react";

function MarketingTranslationProcess() {
  return (
    <section className="bg-darkBlue pt-16 pb-20 lg:pt-20 lg:pb-24">
      <div className="w-11/12 lg:w-8/12 xl:max-w-6xl 2xl:w-7/12 mx-auto">
        <h2 className="font-secondary font-semibold text-[34px] text-gray mb-6 text-center">
          The <span className="text-orange">Marketing</span> Translation Process
        </h2>
        <p className="text-darkMist text-17 text-center">
          After thousands of successful engagements, Tomedes has developed a proven formula and best-practice process for marketing translation to ensure optimal results.
        </p>
        <div className="divider border-b border-gray mt-10 mb-10 border-opacity-25 lg:w-[120%] lg:ml-[-10%]"></div>
        <div className="grid grid-cols-1 gap-14">
          <div>
            <h3 className="font-secondary font-semibold text-24 text-gray mt-7 lg:mt-9 mb-4">1. Project management</h3>
            <p className="text-darkMist text-17">
              Tomedes provides a project management team that can organize and coordinate your whole translation project from beginning to end. We assign a hand-picked personal management team to your
              account, in charge of assisting you throughout the whole process.
            </p>
          </div>
          <div>
            <h3 className="font-secondary font-semibold text-24 text-gray mt-7 lg:mt-9 mb-4">2. Localization research</h3>
            <p className="text-darkMist text-17">
              Even before the marketing translation work begins, our Tomedes specialists, hand-picked to understand your domain, will perform localization research about your content, market niche,
              and competition.
            </p>
          </div>
          <div>
            <h3 className="font-secondary font-semibold text-24 text-gray mt-7 lg:mt-9 mb-4">3. Marketing Translation</h3>
            <p className="text-darkMist text-17">
              The actual translation will be carried out by Tomedes translators who are not only fluent native speakers of your target language but also fluent in the source language, as well as
              experts in the industry of your professional domain.
            </p>
          </div>
          <div>
            <h3 className="font-secondary font-semibold text-24 text-gray mt-7 lg:mt-9 mb-4">4. LQA</h3>
            <p className="text-darkMist text-17">
              Language Quality Assurance begins with Language Quality Analysis. Tomedes subjects all of our translation work to objective measures to ensure optimal effectiveness according to the
              best-practice standards.
            </p>
          </div>
          <div>
            <h3 className="font-secondary font-semibold text-24 text-gray mt-7 lg:mt-9 mb-4">5. QA of Visual Assets</h3>
            <p className="text-darkMist text-17">
              Marketing translation texts rarely stand in isolation. They are invariably part of a context with graphics and, for digital projects, interactive elements on a page or in an app. So, at
              Tomedes, even your visual assets undergo a QA.
            </p>
          </div>
          <div>
            <h3 className="font-secondary font-semibold text-24 text-gray mt-7 lg:mt-9 mb-4">6. Content Integration</h3>
            <p className="text-darkMist text-17">
              We ensure that translated content is fully integrated and contextualized. Your content will reach the last step of integration with the translation. That’s because you need to have a
              final product that can be relatable to your global audience.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default MarketingTranslationProcess;
